// import: styles
import { ApiStage } from 'core/constants/enums/ApiStages.ts';
import { AuthenticationStatus } from 'core/constants/enums/AuthenticationStatus.ts';
import { FirebaseErrors } from 'core/constants/enums/FirebaseErrors.ts';
// import: assets
// import: constants
import { PromptsModalType } from 'core/constants/enums/PromptsModalType.ts';
import { ToastType } from 'core/constants/enums/ToastTypeEnum.ts';
import { sendToast } from 'core/layouts/components/toast/ToastUtils';
import { LOGIN } from 'core/navigation/Routes';
import {
	likeDislikePromptAPIStageSelector,
	likeDislikePromptAsync,
	modelDetailsSelector,
	promptModalTypeSelector,
	promptsCurrentPageSelector,
	promptsTotalPagesSelector,
	randomisedPromptsIdsSelector,
	selectedModelsPromptIndexSelector,
	selectedProfilePagePromptIndexSelector,
	selectedPromptRandomisedIndexSelector,
	setHomePromptsCurrentPage,
	setSelectedModelsPromptIndex,
	setSelectedProfilePagePromptIndex,
	setSelectedPromptRandomisedIndex,
} from 'core/store/reducers/homeReducer/HomeSlice';

import {
	getIsUserAuthenticatedSelector,
	listPromptHistorySelector,
	userPromptHistorySelector,
} from 'core/store/reducers/profileReducer/ProfileSlice';

// import: redux
import {
	setStudioSelectedModels,
	setStudioSettings,
} from 'core/store/reducers/studioReducer/StudioSlice';

// import: utils
import { getCurrentUser } from 'core/utils/firebaseUtil';
import { handleSomethingWentWrongErrorWithToast } from 'core/utils/utils';

// import: components
// import: lazy load components

export const fetchHomePromptsNewPage = () => async (dispatch, getState) => {
	const currentPage = promptsCurrentPageSelector(getState());
	const totalPages = promptsTotalPagesSelector(getState());

	if (currentPage < totalPages) {
		dispatch(setHomePromptsCurrentPage(currentPage + 1));
	}
};

export const handleOpenStudioFromHome = (selectedPrompt) => (dispatch) => {
	dispatch(setStudioSelectedModels({ model: selectedPrompt?.model, replace: true }));
	dispatch(setStudioSettings({ settings: selectedPrompt, fromHomePromptsModal: true }));
};

export const switchSelectedPrompt =
	(step = 1) =>
	(dispatch, getState) => {
		const promptModalType = promptModalTypeSelector(getState());
		let selectedPromptIndex;

		const min = 0;
		let max;

		if (promptModalType === PromptsModalType.HOME_PROMPTS_MODAL) {
			const randomisedPromptsIds = randomisedPromptsIdsSelector(getState());
			selectedPromptIndex = selectedPromptRandomisedIndexSelector(getState());

			max = randomisedPromptsIds.length - 1;
		} else if (promptModalType === PromptsModalType.MODEL_PAGE_PROMPTS_MODAL) {
			const modelDetails = modelDetailsSelector(getState());
			const { prompts } = modelDetails;
			selectedPromptIndex = selectedModelsPromptIndexSelector(getState());

			max = Object.keys(prompts).length - 1;
		} else if (promptModalType === PromptsModalType.PROFILE_PAGE_PROMPTS_MODAL) {
			const isUserAuthenticated = getIsUserAuthenticatedSelector(getState());
			const promptsList =
				isUserAuthenticated === AuthenticationStatus.AUTHENTICATED
					? userPromptHistorySelector(getState())
					: listPromptHistorySelector(getState());
			selectedPromptIndex = selectedProfilePagePromptIndexSelector(getState());

			max = Object.keys(promptsList).length - 1;
		}

		let newIndex = selectedPromptIndex + step;
		if (newIndex < min) newIndex = max;
		if (newIndex > max) newIndex = min;

		if (promptModalType === PromptsModalType.HOME_PROMPTS_MODAL) {
			dispatch(setSelectedPromptRandomisedIndex({ newIndex }));
		} else if (promptModalType === PromptsModalType.MODEL_PAGE_PROMPTS_MODAL) {
			dispatch(setSelectedModelsPromptIndex(newIndex));
		} else if (promptModalType === PromptsModalType.PROFILE_PAGE_PROMPTS_MODAL) {
			dispatch(setSelectedProfilePagePromptIndex(newIndex));
		}
	};

export const handleLikeDislikePrompt =
	({ promptId, liked }) =>
	(dispatch, getState) => {
		const likeDislikePromptAPIStage = likeDislikePromptAPIStageSelector(getState());

		if (likeDislikePromptAPIStage !== ApiStage.LOADING) {
			getCurrentUser()
				.then((user) => {
					if (user) {
						dispatch(
							likeDislikePromptAsync({
								promptId,
								liked,
							}),
						);
					} else {
						window.open(`/${LOGIN}`);
					}
				})
				.catch((err) => {
					if (err.message === FirebaseErrors.EMAIL_NOT_VERIFIED) {
						sendToast(ToastType.DEFAULT_EMAIL_NOT_VERIFIED);
					} else if (err.message === FirebaseErrors.USER_NOT_FOUND) {
						window.open(`/${LOGIN}`);
					} else {
						handleSomethingWentWrongErrorWithToast('Sign in failed', err);
					}
				});
		}
	};
